import React from 'react'
import { browserHistory } from 'react-router'

import NotificationsList from '../Notifications/NotificationsList'
import NavLink from '../Routes/NavLink'

import SearchBar from '../Search/SearchBar'

import { user } from '../../core/controllers/user'

export default class NavBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user_info: {
                firstname: '',
                lastname: '',
                userType: ''
            },
            didGetInfo: false,
        }
    }
    
    ProfileDropdown({profilePicture, userName, logOff, userType, hideName}){
        return (
            <li class="dropdown">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                    <div class="container-fluid" style={{ marginTop: "-15px" }}>
                        <div class="row">
                            <div class="col-sm-12" style={{ display: "flex", alignItems: "center" }}>
                                {profilePicture != null ? (
                                    <img class="profile-pic" src={profilePicture.url} />
                                ) : (
                                    <div class="pe-7s-user fa-3x" style={{ paddingRight: "5px" }}></div>
                                )}
                                {!hideName && (
                                    <span>
                                        {userName}
                                    </span>
                                )}
                                <div class="pe-7s-angle-down fa-2x"></div>
                            </div>
                        </div>
                    </div>
                </a>
                <ul class="dropdown-menu" style={{ textAlign: "center" }}>
                    <li>
                        <NavLink to="/account">
                            My Profile
                        </NavLink>
                    </li>
                    {userType == 'admin' && (
                        <li>
                            <NavLink to="/users">
                                User Management
                            </NavLink>
                        </li>
                    )}
                    {userType == 'admin' && (
                        <li>
                            <NavLink to="/subscription">
                                Subscription
                            </NavLink>
                        </li>
                    )}
                    {userType == 'admin' && (
                        <li>
                            <NavLink to="/settings">
                                Settings
                            </NavLink>
                        </li>
                    )}
                    {userType == 'property-manager' && (
                        <li>
                            <NavLink to="/settings">
                                Settings
                            </NavLink>
                        </li>
                    )}
                    <li>
                        <a href='https://intercom.help/leasey/en' target="_blank">
                            Support
                        </a>
                    </li>
                    <li class="divider"></li>
                    <li><a onClick={logOff}>Log Out</a></li>
                </ul>
            </li>
        )
    }

    componentDidMount() {
        var self = this;
        user.getUserInfo(function (response) {
            response.data['userType'] = user.userInfo.user_type_alias;
            self.setState({
                user_info: response.data,
                didGetInfo: true
            })
        });
    }

    logOff() {
        this.props.unloadUser()
        user.logUserOff();
    }

    render() {
        const user_info = this.state.user_info;
        const profilePicture = user_info.profile_picture;
        const userName = user_info.firstname + " " + user_info.lastname;
        if (!this.state.didGetInfo) {
            return (<nav class="navbar navbar-default navbar-fixed navbar-transparent"></nav>);
        }

        return (
            <nav class="navbar navbar-default navbar-fixed navbar-transparent">
                <div class="container-fluid">
                    <div class="navbar-header">
                        <button type="button" class="navbar-toggle" data-toggle="collapse" onClick={() => {this.props.toggleSidebar()}}>
                            <span class="sr-only">Toggle navigation</span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>
                        <div class="profile-small navbar-toggle">
                            <div class="container-fluid" style={{ marginTop: "-15px" }}>
                                <div>
                                    <div style={{ display: "flex", alignItems: "center", width:"50px" }}>
                                        <NavLink to="/account">
                                            {profilePicture != null ? (
                                                <img class="profile-pic" src={profilePicture.url} />
                                            ) : (
                                                <div class="pe-7s-user fa-3x" style={{ paddingRight: "5px" }}></div>
                                            )}
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.props.showUpcomingToggle && (
                            <button class="navbar-toggle">
                                <span class="pe-7s-gleam " style={{fontSize: "22px", cursor: "pointer", color: "white"}} onClick={this.props.toggleUpcoming}/>
                            </button>
                        )}
                        
                    </div>
                    <div class="collapse navbar-collapse">
                        <ul class="nav navbar-nav navbar-left">
                            {user_info.userType != 'vendor' && (
                                <li>
                                    <SearchBar />
                                </li>
                            )}
                        </ul>
                        <ul class="nav navbar-nav navbar-right">
                            {user_info.userType != 'tenant' && user_info.userType != 'contractor' && user_info.userType != 'vendor' && (
                                <div class="gift-icon-nav-bar">
                                    <NavLink to="/settings/referral">
                                        <i class="pe-7s-gift"></i>
                                    </NavLink >
                                </div>
                            )}
                            {user_info.userType == 'admin' && (
                                <div class="gift-icon-nav-bar header-task-button" onClick={this.props.toggleUpcoming}>
                                    <li>
                                        <i class= {this.props.upcomingActive ? (
                                                "pe-7f-gleam"
                                            ) : (
                                                "pe-7s-gleam"
                                            )}
                                        />
                                    </li>
                                </div>

                            )}
                            {user_info.userType != null && user_info.userType != 'vendor' && (
                                <li>
                                    <NotificationsList />
                                </li>
                            )}
                            <this.ProfileDropdown 
                                profilePicture={profilePicture} 
                                userName={userName}
                                logOff={this.logOff.bind(this)} 
                                userType={user_info.userType}
                            />
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }
};



// WEBPACK FOOTER //
// app/components/NavBar/NavBar.jsx